import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=3c4df0d2&scoped=true&"
import script from "./ProductsView.ts?vue&type=script&lang=ts&"
export * from "./ProductsView.ts?vue&type=script&lang=ts&"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=3c4df0d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4df0d2",
  null
  
)

export default component.exports